// Vendor
import type { Document } from "@contentful/rich-text-types";
import type { Asset, ChainModifiers, LocaleCode } from "contentful";

// Types
import type { TypeMembershipCompare } from "@citizenm/contentful/shared/types/marketing/generated";

export const isMembershipSubscription = <
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry?: IMembershipSubscription<Modifiers, Locales>,
): entry is IMembershipSubscription<Modifiers, Locales> => {
  if (!entry) {
    return false;
  }

  const { description, features } = entry;
  return Boolean(description && features);
};

export const isMembershipFeature = (
  feature?: IMembershipFeature | false,
): feature is IMembershipFeature => {
  const { icon, label } = feature || {};
  return Boolean(icon && label);
};

export interface IMembershipFeature {
  icon: string;
  label: string;
}

export interface IMembershipSubscription<
  Modifiers extends ChainModifiers = "WITHOUT_UNRESOLVABLE_LINKS",
  Locales extends LocaleCode = "en",
> {
  logo?: Asset<Modifiers, Locales>;
  description: Document;
  features: IMembershipFeature[];
}

export type TMembershipCompareCallToAction = Pick<
  TypeMembershipCompare<"WITHOUT_UNRESOLVABLE_LINKS">["fields"],
  "ctaLabel" | "ctaUrl"
>;
